import { useState } from "react";
import { useTranslation } from "react-i18next";

export const useGoogleTranslation = () => {
  const { i18n } = useTranslation();
  const [translation, setTranslation] = useState("");
  const getTranslation = async (text: string, format = "text") => {
    // const data = new URLSearchParams();
    // data.append("key", process.env.NEXT_PUBLIC_GOOGLE_TRANSLATE_API_KEY ?? "");
    // data.append("q", text);
    // data.append("target", i18n.language);
    // data.append("format", format);
    // const translationEndpoint =
    //   "https://translation.googleapis.com/language/translate/v2";
    try {
      // const response = await fetch(`${translationEndpoint}?` + data, {
      //   cache: "default",
      // });
      // const translations = await response.json();
      // if (translations.data) {
      //   setTranslation(translations.data.translations[0].translatedText);
      // }

      const translateResponse = await fetch(`/api/translate`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          text: text,
          target: i18n.language,
          format: format,
          source: "",
        }),
      });

      const result: { text: string } = await translateResponse.json();

      setTranslation(result.text);
    } catch {
      return setTranslation(text);
    }
  };
  return {
    getTranslation,
    translation,
  };
};
